import { BoundForm, Css, boundSelectCardGroupField } from "@homebound/beam";
import { ChangeEventReasonsBoundSelectField } from "src/components/autoPopulateSelects/ChangeEventReasonsBoundSelectField";
import { GuidedChangeEventFormState } from "src/routes/projects/change-events/guided/CreateGuidedChangeEventPage";
import { guidedChangeTypeOptions } from "src/routes/projects/change-events/guided/utils";

type DefineChangeStepProps = { formState: GuidedChangeEventFormState };

export function DefineChangeStep(props: DefineChangeStepProps) {
  const { formState } = props;
  return (
    <div css={Css.df.fdc.gap3.$}>
      <div>
        <h2 css={Css.xl.$}>Describe Change</h2>
        <p css={Css.sm.gray700.$}>Tell us what type of change this is.</p>
      </div>
      <BoundForm
        formState={formState}
        rows={[
          { changeType: boundSelectCardGroupField({ view: "list", options: guidedChangeTypeOptions }) },
          { reactNodeReason: <ChangeEventReasonsBoundSelectField field={formState.reasonId} label="Reason" /> },
        ]}
      />
    </div>
  );
}
